import { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./PreDepartureHiv.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getImportantToKnowDetails,
  getImportantToKnowList,
  getPreDepartureDiseaseDetails,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

interface Props {
  navigation: {
    name: string;
    path: string;
  };
}

const PreDepartureHiv = () => {
  const dispatch: AppDispatch = useDispatch();
  const disease = useSelector(
    (state: RootState) => state.info.preDepartureDiseaseDetails,
  );
  const params = useParams();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const importantToKnowList = useSelector(
    (state: RootState) => state.info.importantToKnowList,
  );
  const lang = useSelector((state: RootState) => state.info.lang);
  const langs: Record<string, string> = {
    ru: "button_ru",
    kg: "button_ky",
    tj: "button_tg",
    uz: "button_uz",
  };

  useEffect(() => {
    dispatch(getPreDepartureDiseaseDetails(Number(params.id)));
    dispatch(getImportantToKnowList());
  }, [params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getPath = (button: string, id: number) => {
    switch (button) {
      case "Информация для мигрантов, живущих с ВИЧ, которые имеют право законно оставаться на территории РФ":
        return `/russia/hiv/migrants/${id}`;
      case "Краткосрочные визиты":
        return `/russia/hiv/visits/${id}`;
      case "Могут ли ЛЖВ-мигранты законно пребывать в России (исключения из закона)":
        return `/russia/hiv/law-exceptions/${id}`;
      default:
        return `/russia/hiv`;
    }
  };

  return (
    <div>
      <Seo
        title="Миграция в Россию с ВИЧ"
        description="Можно ли въезжать и работать в России при ВИЧ-инфекции? Миграционные правила России для иностранцев, живущих с ВИЧ"
        url="https://www.vputi.org/russia/pre-departure/hiv/1"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / Для мигрантов, живущих с ВИЧ",
            path: "/russia",
          }}
        />
        <ContactButtons />

        <div className={s.inner}>
          <div className={s.text}>
            <div className={s.text_title}>{disease?.title_1}</div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_1 ?? "" }}
            ></div>
          </div>
          {
            <div className={s.body_wrapper_2}>
              <div
                className={s.body2}
                dangerouslySetInnerHTML={{ __html: disease?.body_2 ?? "" }}
              ></div>
            </div>
          }
          {
            <div className={s.body_wrapper_3}>
              <div
                className={s.body3}
                dangerouslySetInnerHTML={{ __html: disease?.body_3 ?? "" }}
              ></div>
            </div>
          }
          {
            <div className={s.body_wrapper_4}>
              <div
                className={s.body4}
                dangerouslySetInnerHTML={{ __html: disease?.body_4 ?? "" }}
              ></div>
            </div>
          }
          <div className={s.buttons}>
            {Array.isArray(importantToKnowList) &&
              [...importantToKnowList]
                .reverse()

                .map((it) => {
                  const field = langs[lang] || "button_ru";
                  const buttonText = (it as any)[field] || it.button;

                  return (
                    <Link
                      to={getPath(it.button, it.id)}
                      key={it.id}
                      className={s.button}
                      onClick={() => getImportantToKnowDetails(it.id)}
                    >
                      {buttonText}
                    </Link>
                  );
                })}
          </div>
          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>

          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default PreDepartureHiv;
